import React from 'react';
import Radium from 'radium';

const Svg = (props) => {
	const svgStyle = {
		fill: props.color,
		...props.svgStyle,
	};

	return (
		<div
			style={props.containerStyle}
			onTouchTap={props.onTouchTap}
		>
			<svg
				x={'0px'}
				y={'0px'}
				viewBox={props.viewBox}
				style={svgStyle}
			>
				{props.children}
			</svg>
		</div>
	);
};

Svg.propTypes = {
	children: React.PropTypes.node.isRequired,
	color: React.PropTypes.string.isRequired,
	containerStyle: React.PropTypes.object,
	svgStyle: React.PropTypes.object,
	viewBox: React.PropTypes.string,
	onTouchTap: React.PropTypes.func,
};

Svg.defaultProps = {
	style: {},
	viewBox: '0 0 30 30',
	onTouchTap: () => {},
};


export default Radium(Svg);



// WEBPACK FOOTER //
// ./src/components/images/Svg.js